import { configureStore } from '@reduxjs/toolkit';
import notificationReducer from '../core/Notifications/store/NotificationSlice';
import navigationBarReducer from '../core/Layout/store/NavigationBarSlice';
import securityReducer from '../core/Security/store/SecuritySlice';
import shoppingCartReducer from '../features/ShoppingCart/store/ShoppingCartSlice';
import ordersReducer from '../features/Orders/store/OrdersSlice';
import profileReducer from '../features/Profile/store/ProfileSlice';
import { apiSlice } from './Api';

export const store = configureStore({
  reducer: {
    notifications: notificationReducer,
    security: securityReducer,
    navigationBar: navigationBarReducer,
    shoppingCart: shoppingCartReducer,
    orders: ordersReducer,
    profile: profileReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false }).concat(apiSlice.middleware),
});
